import React from "react";
import NewsletterTwentySix from "../compoent/NewsletterTwentySix";

function NewsletterTwentySixContainer() {
  return <NewsletterTwentySix />;
}

export default NewsletterTwentySixContainer;
